import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import commonEssence from '@sorare/core/src/assets/rewards/common-essence.png';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { invoiceTableMessages } from '@sorare/core/src/lib/glossary';

const Root = styled(Vertical)`
  padding: var(--unit) var(--double-unit);
  background-color: var(--c-nd-100);
`;
const CommonEssenceIcon = styled.img.attrs({ src: commonEssence, alt: '' })`
  height: 1.1em;
`;

const Row = styled(Horizontal)`
  padding: var(--half-unit) 0;
  justify-content: space-between;
`;

type Props = {
  subtotal: number;
  fees: number;
};

export const Summary = ({ subtotal, fees }: Props) => {
  return (
    <Root>
      <Row>
        <BodyM color="var(--c-nd-700)">
          <FormattedMessage {...invoiceTableMessages.subtotal} />
        </BodyM>
        <Horizontal>
          <CommonEssenceIcon />
          <BodyM color="var(--c-nd-700)">{subtotal}</BodyM>
        </Horizontal>
      </Row>
      <Row>
        <BodyM color="var(--c-nd-700)">
          <Tooltip
            title={
              <FormattedMessage
                id="CommonCardPaymentBox.summary.feesTooltip"
                defaultMessage="Fees are calculated based on the subtotal."
              />
            }
          >
            <Horizontal>
              <FormattedMessage {...invoiceTableMessages.fees} />
              <FontAwesomeIcon size="sm" icon={faInfoCircle} />
            </Horizontal>
          </Tooltip>
        </BodyM>
        <Horizontal>
          <CommonEssenceIcon />
          <BodyM color="var(--c-nd-700)">{fees}</BodyM>
        </Horizontal>
      </Row>
    </Root>
  );
};
